<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

const bodyDOM = document.body.classList;
const draftClass = 'draft';

onMounted(() => {
  bodyDOM.add(draftClass);
});

onUnmounted(() => {
  bodyDOM.remove(draftClass);
});
</script>

<template>
  <div class="publish-warning">
    These results are still in draft and cannot be viewed by the public, click Publish to release
    these results.
  </div>
</template>

<style scoped>
.publish-warning {
  background-color: #ce5e5e;
  border: 1px solid #9a4140;
  color: #fff;
  margin: 1rem auto 0;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  max-width: 720px;
  text-align: center;
}
</style>
